import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import NotFound from "../pages/NotFound";

/**
 * Home and NotFound load eagerly (Home is the landing page — we want its first
 * paint immediate). Every other route is code-split with React.lazy so visitors
 * to the marketing/app pages don't download the heavy authenticated screens
 * (the backoffice alone is thousands of lines). Vite emits one chunk per lazy
 * import; a route's JS is fetched only when that route is visited.
 */
const Backoffice = lazy(() => import("../pages/backoffice/page"));
const AdminSetup = lazy(() => import("../pages/admin-setup/page"));
const GetStarted = lazy(() => import("../pages/get-started/page"));
const Pricing = lazy(() => import("../pages/pricing/page"));
const AboutUs = lazy(() => import("../pages/about/page"));
const Login = lazy(() => import("../pages/login/page"));
const Apps = lazy(() => import("../pages/apps/page"));
const WatchAI = lazy(() => import("../pages/apps/watchai/page"));
const WatchAIPrivacy = lazy(() => import("../pages/apps/watchai/privacy/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/get-started",
    element: <GetStarted />,
  },
  {
    path: "/about",
    element: <AboutUs />,
  },
  {
    path: "/apps",
    element: <Apps />,
  },
  {
    path: "/apps/watchai",
    element: <WatchAI />,
  },
  {
    path: "/apps/watchai/privacy",
    element: <WatchAIPrivacy />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/backoffice",
    element: <Backoffice />,
  },
  {
    path: "/admin-setup",
    element: <AdminSetup />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
